import React from 'react';
import { VaDetails } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

export const HousingSituationHelpDetails = () => (
  <VaDetails label="Get help with your housing situation">
    <p>
      We can help you find more resources to help with your housing situation.
    </p>
    <p>
      You can give us more details about your housing situation by submitting VA
      Form 20-10207 (Priority Processing Request). You can submit this form now
      or after you finish your application.
    </p>
    <p>
      You don’t need to submit this form. And submitting this form won’t affect
      your disability compensation claim.
    </p>
    <va-link
      external
      href="https://www.va.gov/forms/20-10207/"
      text="Get VA Form 20-10207 to download"
    />
  </VaDetails>
);
